import AddDetailImage from './AddDetailImage'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../../../../../../../../../../store/actions'

const mapStateToProps = state => ({
  audioSynthesizer: state.audioSynthesizer
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateTopicList: actions.topics.updateTopicList,
      upload: actions.library.upload
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(AddDetailImage)
